import JsonApi, { Params } from 'devour-client';
import { BrandingSettingsPayload } from 'services/payloads/BrandingSettingsPayload';
import { ParkPayload } from 'services/payloads/ParkPayload';
import { PolicySettingPayload } from 'services/payloads/PolicyPayload';
import { ServiceBase } from './ServiceBase';

export class ParkService extends ServiceBase<ParkPayload> {
  constructor(jsonApi: JsonApi) {
    const schema = ParkPayload.getSchema();
    super(jsonApi, 'park', schema, ParkPayload);
    super.define('branding_setting', BrandingSettingsPayload);
    super.define('policy_setting', PolicySettingPayload);
  }

  find = async (params?: Params) => {
    const parks = await super.find({ include: 'branding_setting,policy_setting', ...params });
    return parks;
  }
}
